var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCustomerLang.code"),
                          prop: "productCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t("QuotationCustomerLang.code"),
                          },
                          model: {
                            value: _vm.queryParams.productCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "productCode", $$v)
                            },
                            expression: "queryParams.productCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCustomerLang.Level"),
                          prop: "quotationLevel",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("QuotationCustomerLang.Level"),
                            "option-list": _vm.quotationLevelList,
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.quotationLevel,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "quotationLevel", $$v)
                            },
                            expression: "queryParams.quotationLevel",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "QuotationCustomerLang.LogisticsProduct"
                          ),
                          prop: "productId",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCustomerLang.LogisticsProduct"
                            ),
                            "option-list": _vm.logisticsProductList,
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.productId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "productId", $$v)
                            },
                            expression: "queryParams.productId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCustomerLang.Status"),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("QuotationCustomerLang.Status"),
                            "option-list": _vm.statusList,
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCustomerLang.EffectiveTime"),
                          prop: "effectiveTime",
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            "tip-show": true,
                            placeholder: _vm.$t(
                              "QuotationCustomerLang.EffectiveTime"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParamsTime_effectiveTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime_effectiveTime = $$v
                            },
                            expression: "queryParamsTime_effectiveTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("table.remarkText"),
                          prop: "remark",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("table.remarkText") },
                          model: {
                            value: _vm.queryParams.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "remark", $$v)
                            },
                            expression: "queryParams.remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.onAdd()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled:
                            tableOperationProp.notSelected ||
                            _vm.hasSelectedStatus(1),
                          type: "primary",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onEnable()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("enableText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled:
                            tableOperationProp.notSelected ||
                            _vm.hasSelectedStatus(0),
                          type: "primary",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onDisable()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("QuotationCenter.status3")))]
                    ),
                    _c("BjFrontendExport", {
                      attrs: {
                        disabled: tableOperationProp.notSelected,
                        type: "primary",
                        plain: "",
                        "label-list": _vm.labelList,
                        rows: _vm.selectedRows,
                        "file-name": "Customer Standard Quotation.csv",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessDeleteQuotationCustomerButton",
                            arg: "BusinessDeleteQuotationCustomerButton",
                          },
                        ],
                        attrs: {
                          disabled: tableOperationProp.notSelected,
                          type: "primary",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batchDelete()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("bulkDelText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop == "productId"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.logisticsProductList.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "quoteId"
                                      ? [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.quoteId)),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: { copy: scope.row.quoteId },
                                          }),
                                        ]
                                      : col.prop == "discount"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[col.prop]
                                                  ? _vm.$number2money(
                                                      scope.row[col.prop]
                                                    ) + " %"
                                                  : ""
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop == "quotationLevel"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.quotationLevelList.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop == "quotationMethod"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.quotationMethodList.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop == "status"
                                      ? [
                                          [0, 1, 2].includes(
                                            scope.row[col.prop]
                                          )
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type:
                                                      scope.row[col.prop] == 1
                                                        ? "success"
                                                        : scope.row[col.prop] ==
                                                          2
                                                        ? "warning"
                                                        : "info",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.statusList.bjGet(
                                                            scope.row[col.prop]
                                                          )
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("quotationTimeFilter")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEdit(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("editText")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onCopy(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("copyText")))]
                                      ),
                                      _c(
                                        "el-dropdown",
                                        {
                                          directives: [
                                            {
                                              name: "hasDropdownChildren",
                                              rawName: "v-hasDropdownChildren",
                                            },
                                          ],
                                          on: {
                                            command: function ($event) {
                                              return _vm.command(
                                                $event,
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "el-dropdown-link" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "AccountManagement.common.operate"
                                                  )
                                                )
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-down el-icon--right",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown",
                                            },
                                            [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: { command: "goView" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("detailsText")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    command: "goVIP",
                                                    disabled:
                                                      props.row
                                                        .quotationLevel !== 1,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "QuotationCustomerLang.bindCustomer"
                                                      )
                                                    ) + " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogFormVisible,
            width: "550px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "QuotationCustomerLang.LogisticsProduct"
                            ),
                            prop: "productId",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.LogisticsProduct"
                              ),
                              "option-list": _vm.logisticsProductList,
                            },
                            on: { change: _vm.getProductCode },
                            model: {
                              value: _vm.form.productId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "productId", $$v)
                              },
                              expression: "form.productId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "QuotationCustomerLang.LogisticsProductCode"
                            ),
                            prop: "productCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              disabled: "",
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.LogisticsProductCode"
                              ),
                            },
                            model: {
                              value: _vm.form.productCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "productCode", $$v)
                              },
                              expression: "form.productCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.Currency"),
                            prop: "currency",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.Currency"
                              ),
                              "option-list": _vm.currencyList,
                            },
                            model: {
                              value: _vm.form.currency,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "currency", $$v)
                              },
                              expression: "form.currency",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCustomerLang.Level"),
                            prop: "quotationLevel",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCustomerLang.Level"
                              ),
                              "option-list": _vm.quotationLevelList,
                            },
                            model: {
                              value: _vm.form.quotationLevel,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "quotationLevel", $$v)
                              },
                              expression: "form.quotationLevel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("QuotationCustomerLang.QuotationMethod"),
                    prop: "quotationMethod",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      placeholder: _vm.$t(
                        "QuotationCustomerLang.QuotationMethod"
                      ),
                      "option-list": _vm.quotationMethodList,
                    },
                    model: {
                      value: _vm.form.quotationMethod,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "quotationMethod", $$v)
                      },
                      expression: "form.quotationMethod",
                    },
                  }),
                ],
                1
              ),
              _vm.form.quotationMethod === 1
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "QuotationCustomerLang.ChannelQuotationID"
                                ),
                                prop: "linkId",
                              },
                            },
                            [
                              _c("BjInputNumber", {
                                attrs: {
                                  precision: 0,
                                  maxlength: 18,
                                  "string-mode": "",
                                  "not-auto-zero": "",
                                  placeholder: _vm.$t(
                                    "QuotationCustomerLang.ChannelQuotationID"
                                  ),
                                  clearable: "",
                                },
                                on: { input: _vm.normalizeLinkId },
                                model: {
                                  value: _vm.form.linkId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "linkId", $$v)
                                  },
                                  expression: "form.linkId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("QuotationCustomerLang.Discount"),
                                prop: "discount",
                              },
                            },
                            [
                              _c(
                                "BjInputNumber",
                                {
                                  attrs: {
                                    min: 0,
                                    precision: 2,
                                    maxlength: 10,
                                    "not-auto-zero": "",
                                    placeholder: _vm.$t(
                                      "QuotationCustomerLang.Discount"
                                    ),
                                    clearable: "",
                                  },
                                  on: { input: _vm.normalizeDiscount },
                                  model: {
                                    value: _vm.form.discount,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "discount", $$v)
                                    },
                                    expression: "form.discount",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("QuotationCustomerLang.EffectiveTime"),
                    prop: "effectiveTime",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticClass: "full-width",
                    attrs: {
                      prop: "effectiveTime",
                      format: "dd/MM/yyyy HH:mm:ss",
                      type: "datetimerange",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "start-placeholder": _vm.$t("form.startDateText"),
                      "end-placeholder": _vm.$t("form.endDateText"),
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.queryParamsTime_form_effectiveTime,
                      callback: function ($$v) {
                        _vm.queryParamsTime_form_effectiveTime = $$v
                      },
                      expression: "queryParamsTime_form_effectiveTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("table.remarkText"), prop: "remark" },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      placeholder: _vm.$t("inputText"),
                      type: "textarea",
                      rows: 5,
                      "show-word-limit": "",
                      autosize: "",
                      maxlength: "500",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveAmount()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }